import { NavLink } from "react-router-dom";
import { portfolioCategories } from "../data/siteData";

export default function PortfolioFilter() {
  return (
    <div className="filter-menu">
      {portfolioCategories.map((category) => (
        <NavLink
          key={category.key}
          to={category.to}
          end={category.key === "all"}
          className={({ isActive }) => `filter-link ${isActive ? "active" : ""}`}
        >
          {category.label}
        </NavLink>
      ))}
    </div>
  );
}
